import React from 'react';
import PropTypes from 'prop-types';
import { useMultiOrder } from '../Items/hooks/useMultiOrder';
import { ReturnOrdersWrapper } from './styles';
import { ReturnCard } from './returnLabelGroup';

export const PendingReturns = ({
  printLabel,
  cancelLabel,
  openCancelModal,
  showButtonTrack,
  showButtonReprintLabel,
  showButtonCancel,
  isNotShipped,
}) => {
  const { returnLabels } = useMultiOrder();

  const handlers = {
    printLabel,
    cancelLabel,
    openCancelModal,
  };
  const flags = {
    showButtonTrack,
    showButtonReprintLabel,
    showButtonCancel,
    isNotShipped,
  };

  if (!returnLabels) return null;
  if (returnLabels.length === 0) return null;

  return (
    <ReturnOrdersWrapper className="initiated-returns-container">
      {returnLabels.map((label, index) => (
        <ReturnCard
          {...{ label, handlers, index, flags, key: label.return_id, itemQtyKey: 'qty' }}
        />
      ))}
    </ReturnOrdersWrapper>
  );
};

PendingReturns.propTypes = {
  printLabel: PropTypes.func.isRequired,
  cancelLabel: PropTypes.func.isRequired,
  openCancelModal: PropTypes.func.isRequired,
  showButtonTrack: PropTypes.func.isRequired,
  showButtonReprintLabel: PropTypes.func.isRequired,
  showButtonCancel: PropTypes.func.isRequired,
  isNotShipped: PropTypes.func.isRequired,
};
